/* Header: sticky schaduw, mega menu, dropdowns en het mobiele menu. */
class AsnHeader extends HTMLElement {
  connectedCallback() {
    this.knoppen = Array.from(this.querySelectorAll('[data-asn-toggle]'));
    this.drawer = this.querySelector('#AsnMenuDrawer');
    this.burger = this.querySelector('[data-asn-burger]');

    this.knoppen.forEach((knop) => {
      knop.addEventListener('click', (e) => {
        e.preventDefault();
        const open = knop.getAttribute('aria-expanded') === 'true';
        this.sluitAlles();
        if (!open) this.open(knop);
      });
    });

    // sluiten bij klik buiten, Escape en focus die het menu verlaat
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.sluitAlles();
    });
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.sluitAlles();
        this.sluitDrawer();
        this.querySelector('[aria-expanded="true"]')?.focus();
      }
    });
    this.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!this.contains(document.activeElement)) this.sluitAlles();
      });
    });

    if (this.burger && this.drawer) {
      // Het menu naar het einde van body verplaatsen, zodat geen enkele sectie
      // eroverheen kan vallen. De listeners hieronder blijven gewoon werken.
      document.body.appendChild(this.drawer);
      this.burger.addEventListener('click', () => this.wisselDrawer());
      this.drawer.querySelectorAll('[data-asn-drawer-sluit]').forEach((el) => {
        el.addEventListener('click', () => this.sluitDrawer());
      });
    }

    this.meetUspBar();
    window.addEventListener('resize', () => this.meetUspBar(), { passive: true });

    this.schaduw = this.schaduw.bind(this);
    window.addEventListener('scroll', this.schaduw, { passive: true });
    this.schaduw();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.schaduw);
  }

  /* De pluspunten-balk staat als losse sectie onder de header. Het mega menu
     moet daaronder beginnen, dus meten we de hoogte en geven die door aan CSS. */
  meetUspBar() {
    const balk = document.querySelector('.asn-uspbar');
    this.style.setProperty('--asn-uspbar-h', balk ? balk.offsetHeight + 'px' : '0px');
  }

  open(knop) {
    const paneel = this.querySelector('#' + knop.dataset.asnToggle);
    if (!paneel) return;
    knop.setAttribute('aria-expanded', 'true');
    paneel.hidden = false;
    // in de volgende frame de klasse zetten, zodat de overgang loopt
    requestAnimationFrame(() => paneel.classList.add('is-open'));
  }

  sluitAlles() {
    this.knoppen.forEach((knop) => {
      knop.setAttribute('aria-expanded', 'false');
      const paneel = this.querySelector('#' + knop.dataset.asnToggle);
      if (paneel) {
        paneel.classList.remove('is-open');
        paneel.hidden = true;
      }
    });
  }

  wisselDrawer() {
    this.drawer.hidden ? this.openDrawer() : this.sluitDrawer();
  }

  openDrawer() {
    this.drawer.hidden = false;
    requestAnimationFrame(() => this.drawer.classList.add('is-open'));
    this.burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('asn-geen-scroll');
    this.drawer.querySelector('.asn-drawer__sluit')?.focus();
  }

  sluitDrawer() {
    if (!this.drawer || this.drawer.hidden) return;
    this.drawer.classList.remove('is-open');
    this.burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('asn-geen-scroll');
    setTimeout(() => {
      this.drawer.hidden = true;
    }, 200);
  }

  schaduw() {
    this.classList.toggle('is-gescrold', window.scrollY > 8);
  }
}

customElements.define('asn-header', AsnHeader);

/* Laat de pluspunten-balk op smalle schermen vanzelf doorlopen, een punt per
   keer. Swipen blijft werken; zodra de bezoeker zelf iets doet, stopt het. */
class AsnUspBar extends HTMLElement {
  connectedCallback() {
    this.spoor = this.querySelector('.asn-uspbar__lijst');
    if (!this.spoor || this.dataset.auto !== 'aan') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.tempo = parseInt(this.dataset.tempo, 10) || 4000;
    this.gestopt = false;

    ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach((gebeurtenis) => {
      this.spoor.addEventListener(gebeurtenis, () => this.stop(), { passive: true, once: true });
    });

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.volgende(), this.tempo);
  }

  stop() {
    this.gestopt = true;
    clearInterval(this.timer);
  }

  volgende() {
    // alleen doorlopen als er iets te scrollen valt en de pagina in beeld is
    if (this.gestopt || document.hidden) return;
    const max = this.spoor.scrollWidth - this.spoor.clientWidth;
    if (max <= 2) return;

    const stap = this.spoor.clientWidth;
    const naar = this.spoor.scrollLeft + stap;
    this.spoor.scrollTo({ left: naar > max - 2 ? 0 : naar, behavior: 'smooth' });
  }
}

customElements.define('asn-uspbar', AsnUspBar);
